/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_speed_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I convert km/h to mph quickly?`)
};

const es_uc_speed_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo convierto km/h a mph rápidamente?`)
};

const de_uc_speed_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie rechne ich km/h schnell in mph um?`)
};

const nl_uc_speed_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe converteer ik snel km/u naar mph?`)
};

const fr_uc_speed_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment convertir km/h en mph rapidement ?`)
};

const it_uc_speed_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come converto km/h in mph velocemente?`)
};

const pt_br2_uc_speed_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como faço para converter km/h para mph rapidamente?`)
};

const pt_uc_speed_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como faço uma conversão rápida de km/h para mph?`)
};

const ja_uc_speed_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`km/h を mph にすばやく変換するにはどうすればよいですか?`)
};

const zh_uc_speed_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_speed_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_speed_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_speed_faq1_q", locale)
	if (locale === "en") return en_uc_speed_faq1_q(inputs)
	if (locale === "es") return es_uc_speed_faq1_q(inputs)
	if (locale === "de") return de_uc_speed_faq1_q(inputs)
	if (locale === "nl") return nl_uc_speed_faq1_q(inputs)
	if (locale === "fr") return fr_uc_speed_faq1_q(inputs)
	if (locale === "it") return it_uc_speed_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_speed_faq1_q(inputs)
	if (locale === "pt") return pt_uc_speed_faq1_q(inputs)
	if (locale === "ja") return ja_uc_speed_faq1_q(inputs)
	return zh_uc_speed_faq1_q(inputs)
};